import { LazyLoad } from 'app/utils';

export const ContactFormPage = LazyLoad(
  () => import('./index'),
  (module) => module.ContactFormPage,
);
